import { LabeledIconChip, ParticipationStatusLabel } from 'components';
import { ActionMadeByRole, Participation } from '@app/api';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase,
  },
}));

interface Props {
  participation: Participation;
  sessionId: string;
}

export const TableParticipationStatusList = ({
  participation,
  sessionId,
}: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={classes.statusContainer}>
      <ParticipationStatusLabel
        status={participation.status}
        sessionId={sessionId}
      />
      {participation.cancelledAppointmentResponsible ===
        ActionMadeByRole.AUTOMATIC && (
        <LabeledIconChip
          chipLabel={t('sessions.details.monitoring.status.timedOut')}
          labelColor="yellow"
        />
      )}
    </div>
  );
};
